<template>
  <div class="lion-item">

    <div 
      @click="gotoItem()"
      class="d-block row-img cp"
      >
      <img :src="data.image_url ||''" alt="">
    </div>

    <div 
      class="row-bottom cp"
      @click="gotoItem()"
      >
      {{data.tokenID}}
    </div>
  </div>
</template>

<script>

export default {
  name: 'lionItem',
  components: {},
  props: [
    'data',
    'cfg_no_link',
  ],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    gotoItem(){
      let v = this
      if(v.cfg_no_link){return}
      v.$router.push({
        name: 'lion_item',
        params: {
          id: v.data.tokenID,
        },
      })
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .lion-item{
    background-color: #E6E6E6;
    border-radius: 20px;
    padding-top: 10px;

    .row-title{

      .sp-price-block{
        height: 40px;
        display: flex;
        align-items: center;
        background-color: #fff;
        padding: 10px;
        border-top-left-radius: 50px;
        border-bottom-left-radius: 50px;
      }

      .sp-icon{
        width: 30px;
        height: 30px;
        line-height: 30px;
        color: #fff;
        background-color: $c2;
        text-align: center;
        border-radius: 30px;
      }

      .sp-like{
        display: inline-block;
        height: 40px;
        width: 40px;
        border-radius: 40px;
        line-height: 40px;
        text-align: center;
        color: $c2;
        background-color: #fff;
      }
    }

    .row-img{
      
      height: 200px;
      width: 200px;
      margin: 0px 20px;
      overflow: hidden;

      img{
        border: 3px solid $c;
        border-radius: 10px;
        width: 100%;
        height: 100%;
        object-fit: cover;
        overflow: hidden;
      }
    }

    .row-bottom{
      margin-top: 10px;
      color: #fff;
      background-color: $c;
      text-align: center;
      padding: 10px 0;
      border-radius: 40px;
      font-weight: bold;
      font-size: 30px;
    }

  }
</style>